// Console module for Vuex store
const state = {
  isVisible: false
}

const mutations = {
  setVisible(state, visible) {
    state.isVisible = visible
  },
  toggle(state) {
    state.isVisible = !state.isVisible
  }
}

const actions = {
  open({ commit }) {
    commit('setVisible', true)
  },
  close({ commit }) {
    commit('setVisible', false)
  },
  toggle({ commit }) {
    commit('toggle')
  }
}

const getters = {
  isVisible: state => state.isVisible
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
